export const ordersSliceName = 'orders'
